import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';
import './index.scss';
import { ButtonPrimary, InfoFeedbackScreen, skinVars } from '@telefonica/mistica';
import { useNavigate } from 'react-router-dom';
import navigateParams from '../../../../../utils/navigation/navigateParams';
import { TrackingEvents } from '../../../../../utils/dataTransformation/tracking';
import { isWebviewAndroid, isWebviewIOS } from '../../../../../utils/navigation/controlDevices';

export const FeedbackGco: React.FC = () => {
    const { t } = useTranslation();
    const { trackingScreenView } = new TrackingEvents();
    const navigate = useNavigate();

    const sendToNative = (url: string, title?: string) => {
        const type = 'modeFlow-backgroundBlue';
        const queryParams = {};
        if (navigateParams(type, url, queryParams)) {
            navigate(url);
        }
    };

    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
    }, []);
    return (
        <div className='feedback-gco' style={{ background: skinVars.colors.background }}>
            <InfoFeedbackScreen
                title={t('titleGcoFlow')}
                description={t('subtitleGcoFlow')}
                primaryButton={
                    <ButtonPrimary
                        onPress={() => {
                            sendToNative('/bills');
                        }}
                    >
                        {t('buttonUnderstoodFeedback')}
                    </ButtonPrimary>
                }
            ></InfoFeedbackScreen>
        </div>
    );
};

export default FeedbackGco;
